import script from "./TimeWindows.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeWindows.vue?vue&type=script&setup=true&lang=js"

import "./TimeWindows.vue?vue&type=style&index=0&id=6573f5e9&scoped=true&lang=css"

import exportComponent from "/home/borg/github/Heborg/booking-web/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6573f5e9"]])

export default __exports__